import React from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faChartArea, faMobileAlt } from '@fortawesome/pro-solid-svg-icons';
import appImage from '../../../../assets/free-trial-images/App_Graphic.png';
import alertsImage from '../../../../assets/free-trial-images/Alert_Graphic.png';
import reportsImage from '../../../../assets/free-trial-images/Report_Graphic.png';

function WelcomePage() {
  const history = useHistory();

  const pageStyle = {
    maxWidth: '900px',
  };

  const imageStyle = {
    width: '100%',
    maxWidth: '225px',
    height: '135px',
    objectFit: 'contain',
    objectPosition: 'center',
    flex: '0 0 auto',
  };

  const clickableStyle = {
    cursor: 'pointer',
  };

  const sections = [
    {
      image: alertsImage,
      imageAlt: 'Alert setup screen',
      icon: faBolt,
      title: 'Set up Alerts',
      body: (
        <>
          Start with
          {' '}
          <strong>Alerts</strong>
          , where you can choose your device,
          sensor, and the specific thresholds that represent adverse conditions.
          Once the trigger is set, add
          {' '}
          <strong>actions</strong>
          {' '}
          to define how you
          want to be notified.
        </>
      ),
      onClick: () => history.push('/s/alerts'),
    },
    {
      image: reportsImage,
      imageAlt: 'Sensor report chart',
      icon: faChartArea,
      title: 'Build Reports',
      body: (
        <>
          Head over to
          {' '}
          <strong>Sensor Data &amp; Reports</strong>
          {' '}
          to begin
          exploring your sensor data history. Add multiple readings to a
          visualization to compare conditions and identify trends. Save those
          reports to share with others.
        </>
      ),
      onClick: () => history.push('/s/sensor-data/groups'),
    },
    {
      image: appImage,
      imageAlt: 'Room Alert mobile app',
      icon: faMobileAlt,
      title: 'Download the App',
      body: (
        <>
          Download the
          {' '}
          <strong>Room Alert App</strong>
          {' '}
          for
          {' '}
          <a href="https://apps.apple.com/us/app/room-alert/id6447250947?itsct=apps_box_badge&itscg=30200">iOS</a>
          {' '}
          or
          {' '}
          <a href="https://play.google.com/store/apps/details?id=com.avtramobile&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">Android</a>
          . With the app,
          you will receive native phone notifications when your alerts trigger.
          Built-in chat helps your team work together to resolve adverse
          conditions when they arise.
        </>
      ),
      onClick: null,
    },
  ];

  return (
    <div className="container-fluid py-4 px-3">
      <div className="mx-auto w-100" style={pageStyle}>
        <h1 className="font-weight-bold mb-5" style={{ fontSize: '40px' }}>
          Welcome. Let&apos;s get you covered.
        </h1>

        {sections.map((section) => (
          <div
            className="d-flex flex-column flex-md-row align-items-start mb-4"
            key={section.title}
            onClick={section.onClick}
            style={section.onClick ? clickableStyle : undefined}
          >
            <img
              src={section.image}
              alt={section.imageAlt}
              className="mb-3 mb-md-0 mr-md-4"
              style={imageStyle}
            />

            <div style={{ maxWidth: '650px' }}>
              <h2 className="font-weight-bold mb-2 d-flex align-items-center">
                <FontAwesomeIcon
                  icon={section.icon}
                  className="mr-2"
                  fixedWidth
                />
                {section.title}
              </h2>

              <p className="mb-0" style={{ fontSize: '17px', lineHeight: 1.28 }}>
                {section.body}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WelcomePage;
